import i18n from "config/i18next";

i18n.addResources("es", "tableTransactions", {
  orderNumber: "Nro de orden",
  transaction: "Transacción",
  pickerId: "Id del picker",
  dateAndHour: "Fecha y hora",
  status: "Estado",
  trip: "Viaje",
  origin: "Punto de origen",
  pendingAssignment: "Sin asignar",
  inPickUp: "En retiro",
  assigned: "Asignado",
  inPickUpPoint: "En lugar de retiro",
  inDelivery: "En entrega",
  inDeliveryPoint: "En lugar de entrega",
  delivered: "Entregado",
  inReturnToSender: "En devolución",
  returnedToSender: "Devuelto",
  lost: "Siniestrado",
  cancel: "Cancelado"
});
